import {
  blueYonderIntegrationInputSchema,
  blueYonderLocationSchema,
  WebhookEventType,
} from "@redotech/redo-model/blue-yonder-integration";
import * as z from "zod/v4";

export type BlueYonderLocation = z.infer<typeof blueYonderLocationSchema>;

export const blueYonderIntegrationSchema = z.object({
  retailerCompanyId: z.string(),
  webhookSubscriptionId: z.string(),
  locations: z.array(blueYonderLocationSchema),
  enabled: z.boolean().optional(),
  testMode: z.boolean(),
  processingEvent: z.enum(WebhookEventType).nullable(),
  radiusMiles: z.number().optional(),
  title: z.string().nullish(),
  subtitle: z.string().nullish(),
  locationsText: z.string().nullish(),
});

export type BlueYonderIntegration = z.infer<typeof blueYonderIntegrationSchema>;

export const getBlueYonderIntegration = {
  name: "getBlueYonderIntegration" as const,
  input: z.object({}),
  output: z.object({
    blueYonderIntegration: blueYonderIntegrationSchema.nullable(),
  }),
};

export const setBlueYonderIntegration = {
  name: "setBlueYonderIntegration" as const,
  input: blueYonderIntegrationInputSchema,
  output: z.object({}),
};

export const disconnectBlueYonderIntegration = {
  name: "disconnectBlueYonderIntegration" as const,
  input: z.object({ enabled: z.boolean().optional() }),
  output: z.object({}),
};
